var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFavourite(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.8921 4.99643C15.5516 4.65576 15.1473 4.38552 14.7023 4.20115C14.2574 4.01677 13.7804 3.92187 13.2988 3.92188C12.8171 3.92187 12.3402 4.01677 11.8952 4.20115C11.4502 4.38552 11.0459 4.65576 10.7054 4.99643L9.99878 5.70309L9.29211 4.99643C8.60431 4.30863 7.67147 3.92223 6.69878 3.92223C5.72609 3.92223 4.79324 4.30863 4.10544 4.99643C3.41765 5.68422 3.03125 6.61707 3.03125 7.58976C3.03125 8.56245 3.41765 9.4953 4.10544 10.1831L4.81211 10.8898L9.99878 16.0764L15.1854 10.8898L15.8921 10.1831C16.2328 9.84259 16.503 9.4383 16.6874 8.99333C16.8718 8.54836 16.9667 8.07142 16.9667 7.58976C16.9667 7.1081 16.8718 6.63116 16.6874 6.18619C16.503 5.74122 16.2328 5.33693 15.8921 4.99643V4.99643Z",
    fill: "#EF8B6E"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFavourite);
export default __webpack_public_path__ + "static/media/Favourite.b5b521d742d3afa9630744ac78d71243.svg";
export { ForwardRef as ReactComponent };